<template>
  <div
    class="p-5 arkaplan"
    id="hakkimizda"
  >
  <img src="https://league-mp7static.mlsdigital.net/styles/image_default/s3/images/CrewStadiumVisit.jpg?Zm4SfkcsHPbUjEWhc4.BdpLdJZ_.vJeY&itok=SJNZSlwP" />
    <!-- <div class="card text-center col col-md-3">
      <h5 class="card-header">Hakkımızda</h5>
      <div class="card-body">
        <h5 class="card-title">Kablosuz Beyin nedir?</h5>
        <p class="card-text">
          Kablosuz Beyin pandemi döneminde ortaya çıkmış insanların
          sosyalleşebilmelerini sağlayan sosyal bir topluluktur.
        </p>
      </div>
    </div> -->
    <div class="container p-5 m-5">
      <div class="row">
        <div class="col-lg-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Hakkımızda</h5>
              <p class="card-text">
                Kablosuz Beyin pandemi döneminde ortaya çıkmış insanların
                sosyalleşebilmelerini sağlayan sosyal bir topluluktur. Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              </p>

              <a href="#iletisim" class="btn btn-outline-primary btn-sm">
                Bize Ulaşın
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-4">
          <div class="card">
            <img class="card-img-top" src="" alt="" />

            <div class="card-body">
              <h5 class="card-title">Ekibimiz</h5>
              <p class="card-text">
                Çok dinamik bir ekibimiz var. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Similique, culpa magnam praesentium possimus maiores, suscipit quo a quisquam pariatur natus aspernatur corporis voluptate tempora unde tempore! Quia nisi saepe labore!
                </p>
            <a href="https://discord.kablosuzbeyin.com" target="_blank" class="btn btn-outline-primary btn-sm"
          >Discord</a>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.arkaplan {
    position: relative;
    overflow: hidden;
    padding: 16px;
    height: 660px;
}
.arkaplan img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    opacity: 0.6;
}
</style>
